import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Queensland Mafia Club';
const BASE_URL = 'https://mafiaclub.com.au';
const OG_IMAGE = `${BASE_URL}/logo.jpg`;
const DEFAULT_DESC = 'Клуб спортивной мафии в Брисбене. Играем каждую субботу в Banyo Library.';

interface SeoProps {
  title: string;
  description?: string;
  path?: string;
  noindex?: boolean;
}

export function Seo({ title, description = DEFAULT_DESC, path = '', noindex = false }: SeoProps) {
  const fullTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ru_RU" />
    </Helmet>
  );
}
